'use strict';

var _renderers = require('linksoft/data-tables/renderers');

var _SimpleLookupColumn = require('./SimpleLookupColumn');

var _SimpleLookupColumn2 = _interopRequireDefault(_SimpleLookupColumn);

var _FlagEnumColumn = require('./FlagEnumColumn');

var _FlagEnumColumn2 = _interopRequireDefault(_FlagEnumColumn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _renderers.registerRenderer)(function (opt) {
  return opt.type === 'simple-lookup';
}, _SimpleLookupColumn2.default);
(0, _renderers.registerRenderer)(function (opt) {
  return opt.type === 'flag-enum';
}, _FlagEnumColumn2.default);


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/datatables/index.js
// module id = 424
// module chunks = 0